import "@olmokit/core/forms/select/filled";
import FormsBase from "@olmokit/core/forms/base";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { $ } from "@olmokit/dom";
import { globalConf } from "@olmokit/core/data";
import { updateCart } from "routes/cart";
import "./Shipping.scss";

/**
 * Component: CartShipping
 */
export function CartShipping() {
  console.log("CartShipping mounted.");

  const $root = $('.CartShipping:');

  FormsBase($root, ".ShippingCostForm:", {
    // endpoint: "my-custom-endpoint",
    url: globalConf.cmsApiUrl + "/it/delivery",
    succeded: handleSucceded,
    failed: handleFailed,
  });

  Dependency(".CartShipping:");  

  const $country = $('#of-9-country');
  if($country){
    $country.disabled = true;
  }

  /**
   * Handle succeeded
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleSucceded(formData, instance, response) {
    console.log(response);
    updateCart();
  }

  /**
   * Handle failed
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleFailed(formData, instance, response) {
    console.error(response);
  }  
}
